// extracted by mini-css-extract-plugin
export default {"reset_password_page_wrapper":"ResetPasswordPage_reset_password_page_wrapper__lurJu","reset_form_wrapper":"ResetPasswordPage_reset_form_wrapper__ey9kw"};